export type ImportStep = 'upload' | 'mapping' | 'preview' | 'importing' | 'complete';

export interface ColumnMapping {
  header: string;
  crmField: string;
  confidence: number;
}

export interface ImportPreview {
  headers: string[];
  rows: string[][];
  totalRows: number;
  mappings: ColumnMapping[];
}

export interface ImportResult {
  totalRows: number;
  importedCount: number;
  duplicateCount: number;
  errorCount: number;
  errors: { rowIndex: number; email?: string; message: string }[];
  duplicateEmails?: string[];
}

export const CRM_FIELD_KEYS = [
  'firstName',
  'lastName',
  'email',
  'phone',
  'company',
  'jobTitle',
  'companyUrl',
  'linkedinUrl',
  'tags',
  'skip',
] as const;

export type CrmFieldKey = (typeof CRM_FIELD_KEYS)[number];
